





















































  import store from "../../../store/store";
  import authStore, {WhoAmI} from "../../../store/AuthState";
  import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
  import WhoAmIApi, {WhoAmIResult} from "@/repository/WhoAmIApi";
  @Component({
    components: {
      // Adding imported widgets here
    },
    name: 'SideBar'
  })
  export default class SideBar extends Vue {

    userInfo: WhoAmI = new WhoAmI();
    @Prop()
    parent: string;
    @Prop({required: true})
    sidebarLinks: Array<string>;
    @Prop()
    type: Object;
    @Prop({default: null})
    index: [String, Number];
    @Prop({default:false})
    doNotClose: boolean;
    windowWidth: any = window.innerWidth;

  data: () => {
    round: true,
    userName:string,
    email: string
  };

get isSidebarActive(): boolean {
  return store.state.themeState.isSidebarActive;
}
set isSidebarActive(val: boolean){
  store.commit.themeState.IS_SIDEBAR_ACTIVE(val);
}
get getActive(){
  return this.$destroy();
}

get reduceSidebar(){
  return Boolean(this.isSidebarReduced);
}
get isSidebarReduced(){
  return store.state.themeState.isSidebarReduced;
}
set isSidebarReduced(val: boolean){
  store.commit.themeState.TOGGLE_REDUCE_SIDEBAR(val);
}
    get isSubLinkActive() {
      return sidebarLink => {
        let open = false;
        if (sidebarLink.child) {
          sidebarLink.child.forEach(link => {
            if (this.$route.fullPath == link.url) {
              open = true;
            }
          });
        }

        return open;
      };
    }

    @Watch('windowWidth')
    onPropertyChanged(value: any, oldValue: any) {
      if (value< 1170){
        store.commit.themeState.IS_SIDEBAR_ACTIVE(false);
      }
    }
  /*@Watch("windowWidth")


  watch: {
    '$route'() {
        if(this.windowWidth < 1170 ) store.commit.themeState.IS_SIDEBAR_ACTIVE(store.state.themeState, false);//this.$store.commit('IS_SIDEBAR_ACTIVE', false);
    },
  },*/
  handleWindowResize(event) {
    this.windowWidth = event.currentTarget.innerWidth;
    this.setSidebarWidth();
  }
  setSidebarWidth() {
    if (this.windowWidth < 1170) {
      store.commit.themeState.IS_SIDEBAR_ACTIVE(false);
      //this.$store.commit("IS_SIDEBAR_ACTIVE", false);
      (this.doNotClose = false);
      store.dispatch.themeState.updateSidebarWidth({width:"no-sidebar"});
      //this.$store.dispatch("updateSidebarWidth", "no-sidebar");

    } else {
      store.commit.themeState.IS_SIDEBAR_ACTIVE(true);
      //this.$store.commit("IS_SIDEBAR_ACTIVE", true);
      this.doNotClose = true;
      store.dispatch.themeState.updateSidebarWidth({width:"mini"});
      if (!this.isSidebarReduced){
        store.dispatch.themeState.updateSidebarWidth({width: "default"}); //this.$store.dispatch("updateSidebarWidth", "default");
      }
    }
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.handleWindowResize);

    });
    this.setSidebarWidth();


  }
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
    this.setSidebarWidth();
  }
  async created(){
    let api = new WhoAmIApi();

    let resultOfCheck:WhoAmIResult = await api.getWhoAmI();
    if (resultOfCheck.success){
      let whoAmI = new WhoAmI();
      whoAmI.userName = resultOfCheck.userName;
      whoAmI.email = resultOfCheck.email;
      store.dispatch.authState.addWhoIsInformation({userInfo: whoAmI});
      this.userInfo = new WhoAmI();
      this.userInfo.userName = whoAmI.userName;
      this.userInfo.email = whoAmI.email;
    }
  }
}
